import { Component, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { BxHeaderComponent } from '../bx-header/bx-header.component'
import { StateService } from 'src/app/common/services/state.service'
import { first, finalize } from 'rxjs'
import { AuthService } from 'src/app/common/services/auth.service'
import { ChangePasswordComponent } from 'src/app/modules/dashboard/components/change-password/change-password.component'
import { ConfirmationActionComponent } from 'src/app/common/components/confirmation-action/confirmation-action.component'
import { LoaderService } from 'src/app/services/loader.service'
import { ToastrService } from 'ngx-toastr'
import { UserAuthService } from 'src/app/services/user-auth.service'

enum RequestStatus {
  SUBMITTED = 'SUBMITTED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED'
}

@Component({
    selector: 'app-account-settings',
    imports: [RouterModule, BxHeaderComponent, ChangePasswordComponent, ConfirmationActionComponent],
    templateUrl: './account-settings.component.html',
    styleUrl: './account-settings.component.scss'
})
export class AccountSettingsComponent implements OnInit {
  userEmail: string = ''
  userProfileId: string = ''
  showChangePassword: boolean = false
  showDeleteAccount: boolean = false
  deleteAccountSuccess: boolean = false
  showKeepAccountCard: boolean = false
  showDeleteAccountCard: boolean = false
  hideBackButton: boolean = false

  constructor (
    private stateService: StateService,
    private authService: AuthService,
    private userAuthService: UserAuthService,
    private loaderService: LoaderService,
    private toast: ToastrService
  ) {}

  ngOnInit () {
    this.stateService.userDetails.pipe(first()).subscribe((userDetails: any) => {
      if (userDetails && userDetails?.emailAddress && userDetails?.id) {
        this.userEmail = userDetails.emailAddress
        this.userProfileId = userDetails.id
        this.checkUserDeletionStatus()
      } else {
        this.fetchUserDetails()
      }
    })
  }

  private fetchUserDetails () {
    this.loaderService.show()
    this.userAuthService.getUserDetails().pipe(first(), finalize(() => this.loaderService.hide())).subscribe({
      next: (response: any) => {
        if (response?.body?.items?.length > 0) {
          const userDetails = response.body.items[0]
          this.stateService.userDetails.next(userDetails)
          this.userEmail = userDetails.emailAddress
          this.userProfileId = userDetails.id
          this.checkUserDeletionStatus()
        }
      }
    })
  }

  checkUserDeletionStatus () {
    this.loaderService.show()
    this.userAuthService.getUserStatus(this.userProfileId).pipe(first(), finalize(() => this.loaderService.hide())).subscribe({
      next: (response: any) => {
        if (response?.requestStatus === RequestStatus.SUBMITTED) {
          this.showKeepAccountCard = true
        }
        if (response?.requestStatus === RequestStatus.CANCELLED || response?.requestStatus === RequestStatus.REJECTED || response?.statusCode === 404) {
          this.showDeleteAccountCard = true
        }
      }
    })
  }

  openChangePassword () {
    this.showChangePassword = true
  }

  closeChangePassword () {
    this.showChangePassword = false
    this.hideBackButton = false
  }

  signOutAllDevice () {
    this.authService.signOut()
  }

  openDeleteAccount () {
    this.showDeleteAccount = true
  }

  closeDeleteAccount () {
    this.showDeleteAccount = false
  }

  cancelDeletionRequest () {
    this.loaderService.show()
    this.showKeepAccountCard = false
    this.userAuthService.revokeUser(this.userProfileId).pipe(first()).subscribe({
      next: () => {
       this.toast.success('Your request to account revoke has been successfully received and is being processed')
      },
      error: (err: any) => {
        this.toast.error(err?.error?.message || err?.message || 'Something went wrong')
      },
      complete: () => {
        this.loaderService.hide()
      }
    })
  }

  deleteAccount () {
    this.loaderService.show()
    this.userAuthService.deleteUser(this.userProfileId).pipe(first()).subscribe({
      next: () => {
        this.deleteAccountSuccess = true
      },
      error: (err: any) => {
        this.toast.error(err?.error?.message || err?.message || 'Something went wrong')
      },
      complete: () => {
        this.loaderService.hide()
      }
    })
  }

  doneDeleteAccount () {
    this.authService.signOut()
  }
}
